import { SignUp } from "@clerk/clerk-react";
import { Center } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/(auth)/sign-up/$")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: ({ context }) => {
    if (context.auth.isSignedIn) {
      redirect({
        to: "/",
        throw: true,
      });
    }
  },
  component: SignUpPage,
});

function SignUpPage() {
  const search = Route.useSearch();

  return (
    <Center h="60vh">
      <SignUp
        path="/sign-up"
        signInUrl="/login"
        fallbackRedirectUrl={search.redirect}
      />
    </Center>
  );
}
